/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import Button from '@material-ui/core/Button';

import { getFeatureFlags } from '../../../utils/featureSelectors';
import { dateMMMMDD, dateMMMMDDYYYY } from '../../../utils/dateString';
import { isEmpty } from '../../../utils/object';

class DeliveryDate extends React.Component {
    modifyOrders = () => {
        const { openMmo, itemDetailList, orderData } = this.props;
        openMmo('editDate', itemDetailList, orderData);
    };

    deliveryHelper = (
        {
            arrivalStartDate,
            arrivalEndDate,
            flexGuaranteedFlag,
            flexMessage,
            deliveryDate,
        },
        actualDeliveryDate,
        status,
    ) => {
        const exactDeliveryDate = actualDeliveryDate || deliveryDate;
        let deliveryText = '';
        if (['D', 'U'].indexOf(status) > -1 || arrivalStartDate === '') {
            deliveryText = `${dateMMMMDDYYYY(exactDeliveryDate)}`;
        } else if (arrivalStartDate === arrivalEndDate) {
            deliveryText = `${dateMMMMDDYYYY(arrivalStartDate)}`;
        } else if (
            arrivalStartDate.slice(0, 4) === arrivalEndDate.slice(0, 4)
        ) {
            deliveryText = `Between ${dateMMMMDD(arrivalStartDate)} - ${dateMMMMDDYYYY(arrivalEndDate)}`;
        } else {
            deliveryText = `Between ${dateMMMMDDYYYY(arrivalStartDate)} - ${dateMMMMDDYYYY(arrivalEndDate)}`;
        }
        return (
            <>
                {deliveryText.indexOf('null') === -1 ? (
                    <div>{deliveryText}</div>
                ) : (
                    ''
                )}
                {flexGuaranteedFlag === 'Y' ? (
                    <div className="small bold align-center">{flexMessage}</div>
                ) : (
                    ''
                )}
            </>
        );
    };

    render() {
        const {
            // eslint-disable-next-line object-curly-newline
            data: {
                status,
                actualDeliveryDate,
                firstItemDetailList,
                orderDate,
                isPassport,
            },
            featureFlags,
        } = this.props;
        const passportDeliveryDate = dateMMMMDDYYYY(orderDate);
        const ENABLE_MMO = !isEmpty(featureFlags)
            && featureFlags['is-account-mmo-enabled'] === true;
        return (
            <>
                {isPassport ? (
                    <h2 className="gray-color no-margin-top">
                        Membership Start Date:{' '}
                        <span className="normal body-color no-uppercase">
                            {passportDeliveryDate}
                        </span>
                    </h2>
                ) : (
                    <>
                        <h2 className="gray-color no-margin-top">
                            <div className="split align-center">
                                <div className="align-left">
                                    Delivery Date / Arrives
                                </div>
                                {firstItemDetailList.deliveryDateEnable
                                        === 'true' && ENABLE_MMO ? (
                                // eslint-disable-next-line react/jsx-indent
                                        <Button
                                            className="buttonBlue flex-none min-width-100"
                                            onClick={() => this.modifyOrders()}
                                        >
                                            Modify
                                        </Button>
                                    ) : (
                                        ''
                                    )}
                            </div>
                        </h2>
                        {this.deliveryHelper(
                            firstItemDetailList,
                            actualDeliveryDate,
                            status,
                        )}
                    </>
                )}
            </>
        );
    }
}

DeliveryDate.defaultProps = {
    featureFlags: {},
};

DeliveryDate.propTypes = {
    data: PropTypes.object.isRequired,
    featureFlags: PropTypes.object,
    openMmo: PropTypes.func.isRequired,
    itemDetailList: PropTypes.array.isRequired,
    orderData: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => {
    let featureFlags = {};
    if (state.app) {
        try {
            featureFlags = {
                ...getFeatureFlags(state),
            };
            // eslint-disable-next-line no-empty
        } catch (ex) { }
    }
    return {
        featureFlags,
    };
};

export default connect(
    mapStateToProps,
    null,
)(DeliveryDate);
